import script from "./BillConnectionIncome.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillConnectionIncome.vue?vue&type=script&setup=true&lang=ts"

import "./BillConnectionIncome.vue?vue&type=style&index=0&id=abb3b2ac&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abb3b2ac"]])

export default __exports__